<script setup lang="ts">
import { computed } from 'vue'
import { useRoute } from 'vue-router'
import SiteHeader from '@/components/SiteHeader.vue'
import SiteFooter from '@/components/SiteFooter.vue'
import SideDock from '@/components/SideDock.vue'
import ComplianceModal from '@/components/ComplianceModal.vue'
import { i18n } from '@/i18n'

const route = useRoute()
const showFooter = computed(() => route.meta.hideFooter !== true)
// 合规弹窗仅在首页弹出 (拒绝后的封锁层常驻整站)
const isHome = computed(() => route.path === '/')
// 用 computed 缓存 key, 避免 Transition 内直接读取响应式 route.path
// 导致 query 变化时触发整页 leave 动画 (点击登录卡片后页面消失的根因)
// 并入 i18n.lang: 切换语言时强制重挂载视图, 兜底 setup 期一次性读取的解构
const viewKey = computed(() => route.path + '|' + i18n.lang)
</script>

<template>
  <SiteHeader :key="'header-' + i18n.lang"/>
  <RouterView v-slot="{ Component }">
    <Transition name="page" mode="out-in">
      <component :is="Component" :key="viewKey"/>
    </Transition>
  </RouterView>
  <SiteFooter v-if="showFooter" :key="'footer-' + i18n.lang"/>
  <SideDock :key="'dock-' + i18n.lang"/>
  <ComplianceModal :active="isHome"/>
</template>

<style>
.page-enter-active,
.page-leave-active {
  transition: opacity 0.25s ease, transform 0.25s var(--ease-out-expo);
}

.page-enter-from {
  opacity: 0;
  transform: translateY(8px);
}

.page-leave-to {
  opacity: 0;
  transform: translateY(-8px);
}
</style>
